import React from "react";
import i18n from "i18next";
/* eslint-disable react/prop-types */
export function Webpage(base) {
  return {
    getConfig: function () {
      return {
        name: "Webpage",
        displayName: IdealStudio.i18n.t("Webpage.PluginName"),
        category: "objects",
        icon: "public",
        initialWidth: "70%",
        initialHeight: "500px",
        initialWidthSlide: "70%",
        initialHeightSlide: "60%",
        flavor: "react",
        createFromLibrary: ["webapp", "url"],
        searchIcon: "type",
      };
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            basic: {
              __name: IdealStudio.i18n.t("Webpage.URL"),
              icon: "link",
              buttons: {
                url: {
                  __name: IdealStudio.i18n.t("Webpage.URL_copypaste"),
                  type: "external_provider",
                  accept: "webapp",
                  value: state.url,
                },
                fixedPosition: {
                  __name: IdealStudio.i18n.t("Webpage.fixedPosition"),
                  type: "checkbox",
                  checked: state.fixedPosition,
                },
                /* scrollY: {
                                    __name: IdealStudio.i18n.t('Webpage.y'),
                                    type: 'number',
                                    checked: state.y,
                                },*/
              },
            },
            style: {
              __name: IdealStudio.i18n.t("Webpage.box_style"),
              icon: "palette",
              buttons: {
                padding: {
                  __name: IdealStudio.i18n.t("Webpage.padding"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 100,
                },
                borderWidth: {
                  __name: IdealStudio.i18n.t("Webpage.border_size"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 10,
                },
                borderStyle: {
                  __name: IdealStudio.i18n.t("Webpage.border_style"),
                  type: "select",
                  value: "solid",
                  options: [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset",
                    "initial",
                    "inherit",
                  ],
                  labels: [
                    i18n.t("styles.border_style_options.none") || "none",
                    i18n.t("styles.border_style_options.hidden") || "hidden",
                    i18n.t("styles.border_style_options.dotted") || "dotted",
                    i18n.t("styles.border_style_options.dashed") || "dashed",
                    i18n.t("styles.border_style_options.solid") || "solid",
                    i18n.t("styles.border_style_options.double") || "double",
                    i18n.t("styles.border_style_options.groove") || "groove",
                    i18n.t("styles.border_style_options.ridge") || "ridge",
                    i18n.t("styles.border_style_options.inset") || "inset",
                    i18n.t("styles.border_style_options.outset") || "outset",
                    i18n.t("styles.border_style_options.initial") || "initial",
                    i18n.t("styles.border_style_options.inherit") || "inherit",
                  ],
                },
                borderColor: {
                  __name: IdealStudio.i18n.t("Webpage.border_color"),
                  type: "color",
                  value: "#000000",
                },
                borderRadius: {
                  __name: IdealStudio.i18n.t("Webpage.radius"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 50,
                },
                opacity: {
                  __name: IdealStudio.i18n.t("Webpage.opacity"),
                  type: "range",
                  value: 1,
                  min: 0,
                  max: 1,
                  step: 0.05,
                },
              },
            },
          },
        },
      };
    },
    getInitialState: function () {
      return {
        url: "https://ideaelearning.net/",
        fixedPosition: false,
      };
    },
    getRenderTemplate: function (state) {
      if (state.url && state.url.match("poly.google.com")) {
        return (
          <iframe
            width="100%"
            height="100%"
            src={state.url}
            frameBorder="0"
            style={{
              width: "100%",
              height: "100%",
              pointerEvents: "none",
              zIndex: 0,
              border: "1px solid grey",
            }}
            allowvr="yes"
            allow="vr; xr; accelerometer; magnetometer; gyroscope; autoplay;"
            allowFullScreen
            mozallowfullscreen="true"
            webkitallowfullscreen="true"
            onMouseWheel=""
            scrolling={"no"}
          />
        );
      }
      return (
        <iframe
          style={{
            width: "100%",
            height: "100%",
            zIndex: 0,
            pointerEvents: "none",
            border: "1px solid grey",
          }}
          scrolling={state.fixedPosition ? "no" : "yes"}
          src={state.url}
        />
      );
    },
  };
}

/* eslint-enable react/prop-types */
